<footer class="absolutePosition">
	<div id="footer" class="text-center footerPositioning" style="pointer-events: none;">
		<div class="row" style="pointer-events: all;">
			<div class="col-12" style="display: flex; justify-content: space-between; padding-left: 30px!important; padding-right: 34px!important;">
				<!-- Copyright -->
				<div style="white-space: nowrap;">
					<a style="pointer-events: none;">&copy;{{currentYear}} EdGate Holdings, Inc.</a>
				</div>
				<!-- Icons -->
				<div class="text-center" style="white-space: nowrap;">
					<a class="footerIcons" href="https://twitter.com/journeysmap" target="_blank">
						<i class="icnTwitter"></i>
					</a>
					<a class="footerIcons" href="https://www.youtube.com/channel/UCiT-yFss577fvMLmVfcRXlA" target="_blank">
						<i class="icnYoutube"></i>
					</a>
					<a class="footerIcons" href="https://www.facebook.com/journeysmap" target="_blank">
						<i class="icnFacebookF"></i>
					</a>
					<a class="footerIcons" href="https://www.instagram.com/journeysmap" target="_blank">
						<i class="icnInstagrame"></i>
					</a>
					<a class="footerIcons" href="https://www.linkedin.com/company/18700371/admin" target="_blank" style="padding-right:0px;">
						<i class="icnLinkedinIn"></i>
					</a>
				</div>
				<!--Terms an Privacy-->
				<div style="white-space: nowrap;">
					<a [routerLink]="['/TermsOfService']">Terms & Conditions</a>
					<a [routerLink]="['/PrivacyPolicy']" style="margin-right:3px;"> Privacy Policy</a>
				</div>
			</div>
		</div>
	</div>
</footer>
